import { Row } from "antd";
import classes from "../Pages.module.css";
import DataField from "./DataField";
import axios from "axios";

const BasicDetail = (props) => {
  const handleChange = (e, param) => {
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      newdata[0][param] = e.target.value;
      //  // console.log(newdata);
      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  const handleSChange = async (val, param) => {
    if (param !== "group_code") {
      console.log(`API call skipped because param is ${param}`);

      // Update the state directly for non-group_code params
      props.setData((data) => {
        const newdata = [...data["accountHeader"]];
        newdata[0][param] = val;
        return {
          ...data,
          accountHeader: newdata,
        };
      });

      return; // Stop further execution if param is not "group_code"
    }

    console.log("Value:", val);

    try {
      // Call the API
      const response = await axios.get(
        `https://metalzulu-backend.onrender.com/api/v1/account/additional-data/${val}`,
        { withCredentials: true }
      );

      // Process the response
      const parentCode = response.data.data.rows[0].uniq_code;
      console.log("API Response:", response.data.data);

      // Update the state with the API response
      props.setData((data) => {
        const newdata = [...data["accountHeader"]];
        newdata[0]["parent_group"] = parentCode;
        newdata[0][param] = val;
        return {
          ...data,
          accountHeader: newdata,
        };
      });
    } catch (error) {
      console.error("Error fetching additional data:", error);
    }
  };

  // const handleDChange = (date, dateString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["accountHeader"]];
  //     newdata[0][param] = dateString;
  //     return {
  //       ...data,
  //       accountHeader: newdata,
  //     };
  //   });
  // };

  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            handleChange={handleChange}
            name="ACCOUNT CODE"
            param="account_code"
            value={props.data.account_code}
          />
        )}
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="ACCOUNT NAME"
          param="account_name"
          required={true}
          value={props.data.account_name}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ACC_GROUP_CODE}
          type="Select"
          name="GROUP"
          param="group_code"
          required={true}
          newacc="parent_code"
          value={props.data.group_code}
        />

        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleSChange}
          options={props.ad.ACCOUNT_USED}
          type="Select"
          name="Trans Type"
          required={true}
          param="account_used"
          value={props.data.account_used}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="ADDRESS1"
          param="add1"
          value={props.data.add1}
        />
        {/* <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="ADDRESS2"
          param="add2"
          value={props.data.add2}
        /> */}
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleSChange}
          options={props.ad.CITY_CODE}
          type="Select"
          name="CITY"
          param="city_code"
          value={props.data.city_code}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="PIN CODE"
          type="str"
          param="pin_code"
          value={props.data.pin_code}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="PHONE NO"
          type="str"
          param="ph1"
          value={props.data.ph1}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="PAN NO"
          type="str"
          param="pan_no"
          value={props.data.pan_no}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="EMAIL"
          type="str"
          param="email"
          value={props.data.email}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="BANK ACCOUNT NO"
          type="str"
          param="bank_account_number"
          value={props.data.bank_account_number}
        />
        <DataField
          editMode={props.editMode}
          lg={12}
          md={24}
          handleChange={handleChange}
          name="IFSC CODE"
          type="str"
          param="bank_ifsc_code"
          value={props.data.bank_ifsc_code}
        />
      </Row>
    </div>
  );
};

export default BasicDetail;
